class BelverdiaTheme {
  constructor(){this.compareAt=this.readCompareMap();this.initFaqNav();this.initMenu();this.initDrawer();this.initProductForms();this.initQty();this.initGallery();this.initTimeline();this.initVariantToggle();this.initAnnouncementMarquee();this.initCountdowns();this.initLooxCleanup();this.initReviewsCarousel();this.initReviewsWrite();this.initCartUpsells();this.initCartRemove();this.initCartVariantToggle();this.initBlogCarousels();}
  initFaqNav(){
    const dead=/^\/(?:pages\/)?faq\/?$/i;
    if(dead.test(location.pathname)){
      location.replace('/#faq');
      return;
    }
    const hasFaq=!!document.getElementById('faq');
    const dest=hasFaq?'#faq':'/#faq';
    const isFaq=a=>{
      if(!a)return false;
      if(a.hasAttribute('data-nav-faq'))return true;
      const label=(a.textContent||'').trim().toLowerCase();
      const href=(a.getAttribute('href')||'').toLowerCase();
      return label==='faq'||/\/pages\/faq|(?:^|\/)#faq$|^#faq$|\/faq\/?$/.test(href);
    };
    document.querySelectorAll('.header-nav a, .mobile-nav a, .footer-menu a, a[data-nav-faq]').forEach(a=>{
      if(!isFaq(a))return;
      a.setAttribute('href',dest);
      a.setAttribute('data-nav-faq','');
    });
    document.addEventListener('click',e=>{
      const a=e.target.closest('.header-nav a, .mobile-nav a, .footer-menu a, a[data-nav-faq]');
      if(!a||!isFaq(a))return;
      e.preventDefault();
      if(hasFaq){
        document.getElementById('faq')?.scrollIntoView({behavior:'smooth',block:'start'});
        history.replaceState({},'',`${location.pathname}${location.search}#faq`);
        return;
      }
      location.assign('/#faq');
    });
  }
  initBlogCarousels(){
    document.querySelectorAll('[data-blog-carousel]').forEach(root=>{
      const track=root.querySelector('[data-blog-carousel-track]');
      if(!track)return;
      const scroller=root.querySelector('[data-blog-carousel-scroller]')||track;
      const step=()=>{
        const slide=track.querySelector('.blog-hubband__slide, .blog-prods__slide, [class*="__slide"]');
        if(!slide)return Math.round(scroller.clientWidth*0.7);
        const styles=getComputedStyle(track);
        const gap=parseFloat(styles.columnGap||styles.gap||'0')||0;
        return slide.getBoundingClientRect().width+gap;
      };
      const go=dir=>scroller.scrollBy({left:dir*step(),behavior:'smooth'});
      root.querySelector('[data-blog-carousel-prev]')?.addEventListener('click',()=>go(-1));
      root.querySelector('[data-blog-carousel-next]')?.addEventListener('click',()=>go(1));
    });
  }
  initVariantToggle(){
    document.querySelectorAll('[data-variant-toggle]').forEach(root=>{
      const mapEl=root.querySelector('[data-variant-map]');
      if(!mapEl)return;
      let variants=[];
      try{variants=JSON.parse(mapEl.textContent)}catch(e){return}
      const input=root.querySelector('[name="id"]');
      const priceEl=document.querySelector('.product-info .price');
      const mainImg=document.querySelector('[data-gallery-main]');
      const addBtn=root.closest('form')?.querySelector('[name="add"]');
      const apply=v=>{
        if(!v)return;
        if(input)input.value=v.id;
        root.querySelectorAll('[data-color]').forEach(btn=>{
          const on=btn.getAttribute('data-color')===v.color;
          btn.classList.toggle('is-selected',on);
          btn.setAttribute('aria-checked',on?'true':'false');
        });
        if(priceEl){
          priceEl.innerHTML=v.price+(v.compare?` <s>${v.compare}</s>`:'');
        }
        if(mainImg&&v.image){
          mainImg.src=v.image;
          mainImg.removeAttribute('srcset');
        }
        if(addBtn)addBtn.disabled=!v.available;
        try{
          const url=new URL(location.href);
          url.searchParams.set('variant',String(v.id));
          history.replaceState({},'',url);
        }catch(e){}
      };
      root.querySelectorAll('[data-color]').forEach(btn=>{
        btn.addEventListener('click',()=>{
          apply(variants.find(v=>v.color===btn.getAttribute('data-color')));
        });
      });
    });
  }
  includedCopy(handle){
    const h=String(handle||'');
    if(h.includes('mini')) return 'Inclus : Verdia Mini (éclairage LED, pompe et réservoir 1,6 L), adaptateur secteur, 3 paniers de culture, 3 éponges de germination, 3 dômes de croissance et notice. Nutriments A + B non inclus.';
    if(/verdia-one|bph14/.test(h)) return 'Inclus : bac réservoir, lampe horticole LED et mât réglable, pompe à eau, adaptateur secteur, 14 paniers de culture, 14 éponges de germination, 14 dômes de croissance et nutriments A + B.';
    if(h==='verdia-pro'||h.includes('plus')) return 'Inclus : potager vertical 6 niveaux, réservoir 20 L, pompe à eau, prise intelligente, paniers de culture et accessoires de montage. Nutriments A + B non inclus.';
    return '';
  }
  initQty(){
    if(this.qtyBound)return;
    this.qtyBound=true;
    document.addEventListener('click',e=>{
      const btn=e.target.closest('[data-qty-change]');
      if(!btn)return;
      const wrap=btn.closest('.qty-selector');
      const input=wrap?.querySelector('.qty-input');
      if(!input||input.disabled)return;
      const min=parseInt(input.min||'1',10);
      const next=Math.max(min,(parseInt(input.value||'1',10)||1)+parseInt(btn.dataset.qtyChange,10));
      input.value=next;
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
    document.addEventListener('change',e=>{
      const input=e.target.closest?.('.qty-input')||(e.target.classList?.contains('qty-input')?e.target:null);
      if(!input||!input.closest('[data-cart-qty]'))return;
      this.updateCartQty(input);
    });
  }
  async updateCartQty(input){
    const wrap=input.closest('[data-cart-qty]');
    const key=wrap?.dataset.cartQty;
    if(!key||wrap.dataset.updating==='true')return;
    const min=parseInt(input.min||'1',10);
    const qty=Math.max(min,parseInt(input.value||'1',10)||1);
    input.value=qty;
    wrap.dataset.updating='true';
    wrap.querySelectorAll('button,input').forEach(el=>el.disabled=true);
    try{
      const res=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
      if(!res.ok)throw new Error('qty');
      if(input.closest('.cart-page, .cart-table, .cart-lines')){location.reload();return;}
      await this.refreshCart();
    }catch(err){
      wrap.querySelectorAll('button,input').forEach(el=>el.disabled=false);
      wrap.dataset.updating='false';
    }
  }
  initTimeline(){
    document.querySelectorAll('[data-timeline-gallery]').forEach(root=>{
      const track=root.querySelector('[data-timeline-track]');
      if(!track)return;
      const go=dir=>track.scrollBy({left:dir*track.clientWidth,behavior:'smooth'});
      root.querySelector('[data-timeline-prev]')?.addEventListener('click',()=>go(-1));
      root.querySelector('[data-timeline-next]')?.addEventListener('click',()=>go(1));
    });
  }
  initGallery(){
    document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
      const main=gallery.querySelector('[data-gallery-main]');
      const thumbs=[...gallery.querySelectorAll('[data-thumb]')];
      this.fitStickyGallery(gallery);
      if(!main||!thumbs.length)return;
      const show=index=>{
        const i=(index+thumbs.length)%thumbs.length;
        const thumb=thumbs[i];
        thumbs.forEach(t=>t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        main.src=thumb.dataset.full;
        if(thumb.dataset.srcset)main.srcset=thumb.dataset.srcset;
        const scroller=thumb.closest('.product-thumbs');
        if(scroller&&scroller.scrollWidth>scroller.clientWidth+4){
          const left=Math.max(0,thumb.offsetLeft-8);
          scroller.scrollTo({left,behavior:'smooth'});
        }
      };
      const current=()=>Math.max(0,thumbs.findIndex(t=>t.classList.contains('is-active')));
      thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(current()-1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(current()+1));
    });
  }
  fitStickyGallery(gallery){
    const media=gallery.querySelector('.product-media--main');
    const thumbs=gallery.querySelector('.product-thumbs');
    const desktop=window.matchMedia('(min-width:991px)');
    const chrome=()=>{
      const header=document.querySelector('.site-header');
      const hr=header?header.getBoundingClientRect():null;
      const headerH=hr?Math.round(hr.height):72;
      const headerBottom=hr?Math.max(0,Math.round(hr.bottom)):headerH;
      const bar=document.querySelector('#preview-bar-iframe,.preview-bar-container,.shopify-preview-bar');
      const barH=bar?Math.round(bar.getBoundingClientRect().height):0;
      const vh=Math.round((window.visualViewport&&window.visualViewport.height)||window.innerHeight);
      return {headerH,headerBottom,barH,vh};
    };
    const apply=()=>{
      if(!desktop.matches){
        gallery.classList.remove('is-ready-to-stick');
        document.documentElement.style.removeProperty('--gallery-sticky-top');
        gallery.style.removeProperty('max-height');
        if(media){
          media.style.removeProperty('width');
          media.style.removeProperty('height');
          media.style.removeProperty('max-width');
        }
        if(thumbs) thumbs.style.removeProperty('width');
        return;
      }
      const {headerH,headerBottom,barH,vh}=chrome();
      const gap=parseFloat(getComputedStyle(gallery).rowGap||getComputedStyle(gallery).gap)||12;
      const thumbsH=thumbs?Math.ceil(thumbs.getBoundingClientRect().height):0;
      const stickyGap=12;
      const room=16+barH;
      const available=Math.max(280,vh-headerH-stickyGap-room);
      const square=Math.max(220,Math.min(gallery.clientWidth||0,available-(thumbsH?thumbsH+gap:0)));
      document.documentElement.style.setProperty('--gallery-sticky-top',(headerH+stickyGap)+'px');
      gallery.style.maxHeight=available+'px';
      if(media){
        media.style.width=square+'px';
        media.style.height=square+'px';
        media.style.maxWidth='100%';
      }
      if(thumbs) thumbs.style.width=square+'px';
      const r=(media||gallery).getBoundingClientRect();
      const fully=r.top>=headerBottom+stickyGap-1 && r.bottom<=vh-barH+1;
      if(fully) gallery.classList.add('is-ready-to-stick');
    };
    apply();
    requestAnimationFrame(apply);
    if(gallery.dataset.fitBound)return;
    gallery.dataset.fitBound='true';
    window.addEventListener('resize',apply,{passive:true});
    window.addEventListener('scroll',apply,{passive:true});
  }
  initReviewsCarousel(){
    const starPath='<path fill="currentColor" d="M24 9.425c0 .212-.125.443-.375.693l-5.236 5.105 1.24 7.212c.01.067.015.164.015.289a.85.85 0 0 1-.151.511.51.51 0 0 1-.44.21c-.183 0-.375-.058-.577-.174L12 19.869l-6.476 3.404c-.212.115-.404.173-.577.173-.202 0-.353-.07-.454-.21a.85.85 0 0 1-.152-.511c0-.058.01-.154.03-.289l1.24-7.211-5.25-5.106C.12 9.858 0 9.628 0 9.425c0-.355.27-.577.808-.663l7.24-1.053 3.245-6.562c.183-.395.418-.592.707-.592s.524.197.707.592l3.245 6.562 7.24 1.053c.539.086.808.308.808.663Z"/>';
    const starsHtml=`<span class="review-stars" aria-hidden="true">${Array.from({length:5},()=>`<svg viewBox="0 0 24 24" width="12" height="12">${starPath}</svg>`).join('')}</span>`;
    const checkHtml='<svg class="review-verified__icon" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><circle cx="8" cy="8" r="7" fill="currentColor"/><path d="M4.6 8.2 7 10.6l4.6-5.2" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const emptyIcon='<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="12" cy="8" r="3.5"/><path d="M5 20c.9-4 3.2-6 7-6s6.1 2 7 6"/></svg>';
    const productNames={mini:'Verdia Mini',one:'Verdia One',plus:'Verdia Plus',go:'Verdia Go'};
    const cleanText=s=>String(s||'').replace(/^\[[\d\-T:\s.]+\]\s*/,'').replace(/\s+/g,' ').trim();
    document.querySelectorAll('[data-reviews-carousel]').forEach(async section=>{
      const src=section.getAttribute('data-reviews-src');
      const track=section.querySelector('[data-reviews-track]');
      const scroller=section.querySelector('[data-reviews-scroller]');
      if(!src||!track)return;
      let reviews=[];
      try{reviews=await fetch(src).then(r=>r.json())}catch(e){return}
      const productFilter=section.getAttribute('data-reviews-product')||'one';
      const all=(reviews||[]).filter(r=>r&&cleanText(r.text));
      const photoFirst=(a,b)=>Number(Boolean(String(b.img||'').trim()))-Number(Boolean(String(a.img||'').trim()));
      if(productFilter==='all'){
        const by={mini:[],one:[],plus:[],go:[]};
        all.forEach(r=>{(by[String(r.product||'one')]||by.one).push(r)});
        Object.keys(by).forEach(k=>by[k].sort(photoFirst));
        reviews=[];
        for(let i=0;reviews.length<all.length;i+=1){
          ['go','mini','one','plus'].forEach(k=>{if(by[k][i])reviews.push(by[k][i])});
        }
      }else{
        reviews=all.filter(r=>(String(r.product||'one'))===productFilter);
        if(!reviews.length && productFilter==='plus') reviews=all.filter(r=>(String(r.product||'one'))==='one');
        reviews.sort(photoFirst);
      }
      if(!reviews.length)return;
      const urls={
        mini:section.getAttribute('data-reviews-url-mini')||'',
        one:section.getAttribute('data-reviews-url-one')||'',
        plus:section.getAttribute('data-reviews-url-plus')||'',
        go:section.getAttribute('data-reviews-url-go')||''
      };
      const card=(r,i)=>{
        const key=String(r.product||'one');
        const productName=productNames[key]||productNames.one;
        const text=cleanText(r.text);
        const img=String(r.img||'').trim();
        const date=String(r.date||'').trim();
        const displayName=String(r.name||'').trim();
        const name=this.escape(!displayName || /^acheteur$/i.test(displayName) ? 'J.M.' : displayName);
        const media=img
          ? `<span class="review-slide__media"><img src="${this.escape(img)}" alt="" loading="lazy"></span>`
          : `<span class="review-slide__media review-slide__media--empty">${emptyIcon}</span>`;
        return `<button type="button" class="review-slide" data-review-open="${i}">${media}<span class="review-slide__stars">${starsHtml}</span><span class="review-slide__body"><span class="review-slide__verified">${checkHtml}${(window.BV_I18N||{}).verified_review||'Avis vérifié'}</span><strong class="review-slide__name">${name}</strong>${date?`<span class="review-slide__date">${this.escape(date)}</span>`:''}<span class="review-slide__text">${this.escape(text)}</span><span class="review-slide__product">${this.escape(productName)}</span></span></button>`;
      };
      track.innerHTML=reviews.map(card).join('');
      const prev=section.querySelector('[data-reviews-prev]');
      const next=section.querySelector('[data-reviews-next]');
      const step=()=>{
        const slide=track.querySelector('.review-slide');
        if(!slide||!scroller)return 280;
        const gap=parseFloat(getComputedStyle(track).gap)||16;
        return slide.getBoundingClientRect().width+gap;
      };
      const updateNav=()=>{
        if(!scroller)return;
        const max=scroller.scrollWidth-scroller.clientWidth-4;
        if(prev)prev.hidden=scroller.scrollLeft<=4;
        if(next)next.hidden=scroller.scrollLeft>=max;
      };
      prev?.addEventListener('click',()=>scroller?.scrollBy({left:-step(),behavior:'smooth'}));
      next?.addEventListener('click',()=>scroller?.scrollBy({left:step(),behavior:'smooth'}));
      scroller?.addEventListener('scroll',updateNav,{passive:true});
      updateNav();
      const dialog=section.querySelector('[data-review-dialog]');
      if(dialog && dialog.parentElement!==document.body) document.body.appendChild(dialog);
      const mediaEl=dialog?.querySelector('[data-review-dialog-media]');
      const nameEl=dialog?.querySelector('[data-review-dialog-name]');
      const dateEl=dialog?.querySelector('[data-review-dialog-date]');
      const textEl=dialog?.querySelector('[data-review-dialog-text]');
      const productEl=dialog?.querySelector('[data-review-dialog-product]');
      const linkEl=dialog?.querySelector('[data-review-dialog-link]');
      const infoBtn=dialog?.querySelector('[data-review-dialog-info]');
      const tip=dialog?.querySelector('[data-review-dialog-tip]');
      const restoreScroll=(x,y)=>{
        const root=document.documentElement;
        const prev=root.style.scrollBehavior;
        root.style.scrollBehavior='auto';
        window.scrollTo(x,y);
        requestAnimationFrame(()=>{
          window.scrollTo(x,y);
          root.style.scrollBehavior=prev;
        });
      };
      let lastScroll=[window.scrollX,window.scrollY];
      const openReview=r=>{
        if(!dialog)return;
        const key=String(r.product||'one');
        const productName=productNames[key]||productNames.one;
        const imgs=(Array.isArray(r.imgs)?r.imgs:[]).map(u=>String(u||'').trim()).filter(Boolean);
        const img=String(r.img||'').trim();
        if(!imgs.length && img)imgs.push(img);
        const url=urls[key]||'';
        if(mediaEl){
          mediaEl.classList.toggle('review-dialog__media--empty',!imgs.length);
          if(!imgs.length){
            mediaEl.innerHTML=emptyIcon;
          }else if(imgs.length===1){
            mediaEl.innerHTML=`<img src="${this.escape(imgs[0])}" alt="">`;
          }else{
            const slides=imgs.map(u=>`<div class="review-dialog__gallery-slide"><img src="${this.escape(u)}" alt=""></div>`).join('');
            const dots=imgs.map((_,i)=>`<button type="button" class="review-dialog__gallery-dot${i===0?' is-active':''}" data-gallery-dot="${i}" aria-label="Photo ${i+1}"></button>`).join('');
            mediaEl.innerHTML=`<div class="review-dialog__gallery" data-review-gallery><div class="review-dialog__gallery-track" data-gallery-track>${slides}</div></div><div class="review-dialog__gallery-dots">${dots}</div>`;
            const track=mediaEl.querySelector('[data-gallery-track]');
            const dotEls=Array.from(mediaEl.querySelectorAll('[data-gallery-dot]'));
            const setActive=i=>dotEls.forEach((d,idx)=>d.classList.toggle('is-active',idx===i));
            dotEls.forEach(d=>d.addEventListener('click',()=>{
              const i=Number(d.getAttribute('data-gallery-dot'));
              track.scrollTo({left:track.clientWidth*i,behavior:'smooth'});
            }));
            let scrollTimer;
            track.addEventListener('scroll',()=>{
              clearTimeout(scrollTimer);
              scrollTimer=setTimeout(()=>{
                const i=Math.round(track.scrollLeft/track.clientWidth);
                setActive(i);
              },80);
            },{passive:true});
          }
        }
        if(nameEl){
          const displayName=String(r.name||'').trim();
          nameEl.textContent=!displayName || /^acheteur$/i.test(displayName) ? 'J.M.' : displayName;
        }
        if(dateEl)dateEl.textContent=r.date||'';
        if(textEl)textEl.textContent=cleanText(r.text);
        if(productEl)productEl.textContent=productName;
        if(linkEl){
          if(url){linkEl.href=url;linkEl.hidden=false;}
          else{linkEl.removeAttribute('href');linkEl.hidden=true;}
        }
        if(tip)tip.hidden=true;
        if(infoBtn)infoBtn.setAttribute('aria-expanded','false');
        lastScroll=[window.scrollX,window.scrollY];
        if(typeof dialog.showModal==='function')dialog.showModal();
        else dialog.setAttribute('open','');
        dialog.querySelector('.review-dialog__close')?.focus({preventScroll:true});
        restoreScroll(lastScroll[0],lastScroll[1]);
      };
      track.addEventListener('click',e=>{
        const btn=e.target.closest('[data-review-open]');
        if(!btn)return;
        e.preventDefault();
        const r=reviews[Number(btn.getAttribute('data-review-open'))];
        if(r)openReview(r);
      });
      infoBtn?.addEventListener('click',e=>{
        e.stopPropagation();
        if(!tip)return;
        const open=tip.hidden;
        tip.hidden=!open;
        infoBtn.setAttribute('aria-expanded',open?'true':'false');
      });
      dialog?.addEventListener('click',e=>{
        if(e.target===dialog)dialog.close();
      });
      dialog?.addEventListener('close',()=>{
        if(tip)tip.hidden=true;
        restoreScroll(lastScroll[0],lastScroll[1]);
      });
    });
    document.querySelectorAll('loox-card-carousel-widget, loox-dynamic-carousel-widget, iframe[src*="loox.io"], a.branding').forEach(el=>{if(this.isLooxWriteFrame(el))return;el.remove();});
  }
  isLooxWriteFrame(el){
    if(!el)return false;
    const id=String(el.id||'');
    const src=String(el.src||el.getAttribute?.('src')||'');
    const cls=String(el.className||'');
    if(id==='looxDialog'||id==='loox-review-form-ugc-dialog'||id.startsWith('looxOverlay'))return true;
    if(/\/write\/|\/ugc\/review-form/.test(src))return true;
    if(cls.includes('loox-overlay'))return true;
    if(el.closest?.('.loox-overlay,[id^="looxOverlay"]'))return true;
    return false;
  }
  initReviewsWrite(){
    const openWrite=id=>{
      const n=Number(id);
      if(!n)return false;
      if(typeof window.looxWrite==='function'){window.looxWrite(n);return true;}
      if(window.LOOX&&typeof LOOX.showReviewForm==='function'){LOOX.showReviewForm(n,window.loox_lang||'fr');return true;}
      return false;
    };
    document.querySelectorAll('[data-loox-write]').forEach(btn=>{
      btn.addEventListener('click',()=>{
        const id=btn.getAttribute('data-loox-write');
        if(openWrite(id))return;
        let tries=0;
        const t=setInterval(()=>{
          tries+=1;
          if(openWrite(id)||tries>50)clearInterval(t);
        },100);
      });
    });
  }
  initLooxCleanup(){
    const cleanText=s=>String(s||'').replace(/BPH\s*14\s*[–—\-:]+\s*/gi,'').replace(/\bBPH\s*14\b/gi,'Verdia One');
    const cleanHref=s=>String(s||'').replace(/bph14-potager-hydroponique-dinterieur/gi,'verdia-one').replace(/verdia-one-retired/gi,'verdia-one').replace(/\/products\/verdia-one-1\b/gi,'/products/verdia-one');
    const isBrand=el=>{
      const text=(el.textContent||'').trim().toLowerCase();
      const href=(el.getAttribute&&el.getAttribute('href')||'').toLowerCase();
      const cls=(el.className&&String(el.className)||'').toLowerCase();
      return cls.includes('loox-brand')||cls.includes('loox-powered')||cls.includes('wordmark')||cls==='branding'||text.includes('powered by loox')||text.includes('propulsé par')||text.includes('propulse par')||(href.includes('loox.io')&&(text==='loox'||text.includes('powered')||text.includes('propuls')||text===''));
    };
    const cleanRoot=root=>{
      if(!root)return;
      if(root.nodeType===3){
        const next=cleanText(root.nodeValue);
        if(next!==root.nodeValue)root.nodeValue=next;
        return;
      }
      if(root.querySelectorAll){
        root.querySelectorAll('a, img, svg, span, div, p').forEach(el=>{if(el.closest?.('.loox-overlay,[id^="looxOverlay"]'))return;if(isBrand(el))el.style.setProperty('display','none','important');});
        root.querySelectorAll('a[href*="bph14"], a[href*="BPH14"]').forEach(a=>{
          const href=cleanHref(a.getAttribute('href'));
          if(href!==a.getAttribute('href'))a.setAttribute('href',href);
        });
        ['title','aria-label','alt','data-product-name','data-name'].forEach(attr=>{
          root.querySelectorAll('['+attr+']').forEach(el=>{
            const v=el.getAttribute(attr);
            const n=cleanHref(cleanText(v));
            if(n!==v)el.setAttribute(attr,n);
          });
        });
      }
      const walk=root.createTreeWalker?root:document;
      if(root.childNodes){
        const tw=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null);
        let node;
        while((node=tw.nextNode())){
          const parent=node.parentElement;
          if(parent&&(parent.tagName==='SCRIPT'||parent.tagName==='STYLE'||parent.tagName==='NOSCRIPT'))continue;
          const next=cleanText(node.nodeValue);
          if(next!==node.nodeValue)node.nodeValue=next;
        }
      }
      if(root.querySelectorAll)root.querySelectorAll('*').forEach(el=>{if(el.shadowRoot)cleanRoot(el.shadowRoot);});
    };
    let t;
    const run=()=>{
      clearTimeout(t);
      t=setTimeout(()=>{
        document.querySelectorAll('loox-card-carousel-widget, loox-dynamic-carousel-widget, iframe[src*="loox.io"]').forEach(el=>{if(this.isLooxWriteFrame(el))return;el.remove();});
        document.querySelectorAll('.shopify-block.shopify-app-block').forEach(el=>{
          const visible=[...el.querySelectorAll('*')].some(n=>{
            if(['SCRIPT','STYLE','NOSCRIPT','LINK','META'].includes(n.tagName))return false;
            const cs=getComputedStyle(n);
            if(cs.display==='none'||cs.visibility==='hidden')return false;
            return n.getBoundingClientRect().height>2;
          });
          if(!visible){
            el.style.setProperty('display','none','important');
            el.style.setProperty('height','0','important');
            el.style.setProperty('padding','0','important');
            el.style.setProperty('margin','0','important');
            el.style.setProperty('overflow','hidden','important');
          }
        });
        cleanRoot(document);
      },80);
    };
    run();
    new MutationObserver(run).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
  }
  initMenu(){const btn=document.querySelector('[data-mobile-menu]');const nav=document.querySelector('[data-mobile-nav]');if(!btn||!nav)return;btn.addEventListener('click',()=>{nav.classList.toggle('is-open');btn.setAttribute('aria-expanded',nav.classList.contains('is-open'))});nav.querySelectorAll('a').forEach((link)=>{link.addEventListener('click',()=>{nav.classList.remove('is-open');btn.setAttribute('aria-expanded','false')})});}
  initDrawer(){const drawer=document.querySelector('[data-cart-drawer]');const overlay=document.querySelector('[data-drawer-overlay]');const openers=document.querySelectorAll('[data-open-cart]');const close=()=>{drawer?.classList.remove('is-open');overlay?.classList.remove('is-open');document.body.style.overflow='';};const open=()=>{drawer?.classList.add('is-open');overlay?.classList.add('is-open');document.body.style.overflow='hidden';};openers.forEach(b=>b.addEventListener('click',e=>{e.preventDefault();open()}));document.querySelectorAll('[data-close-cart]').forEach(b=>b.addEventListener('click',close));overlay?.addEventListener('click',close);document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});this.openCart=open;}
  initProductForms(){document.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{if(form.dataset.ajaxBound)return;form.dataset.ajaxBound='true';form.addEventListener('submit',async e=>{if(!window.fetch)return;e.preventDefault();const button=form.querySelector('[type="submit"][name="add"],[type="submit"]');const original=button?.innerHTML;try{if(button){button.disabled=true;button.textContent=(window.BV_I18N||{}).adding||'Ajout…'}const fd=new FormData(form);const id=Number(fd.get('id'));const qty=Number(fd.get('quantity')||1)||1;const extras=[...document.querySelectorAll('[data-upsells-context="product"] [data-upsell-check]:checked')].filter(el=>el.dataset.inCart!=='true'&&el.value).map(el=>({id:Number(el.value),quantity:1})).filter(item=>item.id&&item.id!==id);const items=[{id,quantity:qty},...extras];const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});if(!res.ok)throw new Error('Cart error');await this.refreshCart();this.openCart?.();}catch(err){form.submit();}finally{if(button){button.disabled=false;button.innerHTML=original}}})});}
  initCartUpsells(){
    document.querySelectorAll('[data-upsell-check]').forEach(input=>{
      if(input.dataset.bound)return;
      input.dataset.bound='true';
      input.addEventListener('change',async()=>{
        const box=input.closest('[data-upsells]');
        const context=box?.dataset.upsellsContext;
        if(context==='product')return;
        input.disabled=true;
        try{
          if(input.checked){
            const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(input.value),quantity:1}]})});
            if(!res.ok)throw new Error('add');
          }else{
            const cart=await fetch('/cart.js').then(r=>r.json());
            const line=(cart.items||[]).find(i=>String(i.id)===String(input.value)||String(i.variant_id)===String(input.value)||String(i.product_id)===String(input.dataset.productId));
            if(line){
              const res=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:line.key,quantity:0})});
              if(!res.ok)throw new Error('change');
            }
          }
          if(context==='cart'){location.reload();return;}
          await this.refreshCart();
        }catch(err){
          input.checked=!input.checked;
        }finally{
          input.disabled=false;
        }
      });
    });
    fetch('/cart.js').then(r=>r.json()).then(cart=>this.syncUpsells(cart)).catch(()=>{});
  }
  cartHasPotager(cart){
    const el=document.querySelector('[data-potager-ids]');
    let ids=[];
    try{ids=JSON.parse(el?el.textContent:'[]')}catch(e){ids=[]}
    const idSet=new Set((ids||[]).map(String));
    return (cart.items||[]).some(i=>{
      if(idSet.has(String(i.product_id))) return true;
      const h=String(i.handle||'');
      return h.includes('mini')||/verdia-one|bph14/.test(h);
    });
  }
  syncUpsells(cart){
    const ids=new Set((cart.items||[]).map(i=>String(i.product_id)));
    const requireEl=document.querySelector('[data-upsells-require-potager]');
    const requirePotager=!requireEl||requireEl.getAttribute('data-upsells-require-potager')!=='false';
    const allow=!requirePotager||this.cartHasPotager(cart);
    document.querySelectorAll('[data-upsell-item]').forEach(row=>{
      const inCart=ids.has(String(row.dataset.productId));
      const context=row.closest('[data-upsells]')?.dataset.upsellsContext;
      const input=row.querySelector('[data-upsell-check]');
      if(context==='product'){
        if(!input)return;
        input.dataset.inCart=inCart?'true':'false';
        if(inCart){input.checked=true;input.disabled=true;}
        else{input.disabled=false;}
        row.classList.toggle('is-in-cart',inCart);
      }else{
        row.hidden=false;
        if(input){
          input.dataset.inCart=inCart?'true':'false';
          if(inCart){input.checked=true;input.disabled=true;}
          else{input.checked=false;input.disabled=false;}
        }
        row.classList.toggle('is-in-cart',inCart);
      }
    });
    document.querySelectorAll('[data-upsells]').forEach(box=>{
      if(box.dataset.upsellsContext==='product')return;
      const hasItems=!!box.querySelector('[data-upsell-item]');
      const context=box.dataset.upsellsContext;
      const boxAllow=context==='cart'?!!cart.item_count:allow;
      box.hidden=!cart.item_count||!hasItems||!boxAllow;
    });
  }
  initCountdowns(){const els=document.querySelectorAll('[data-countdown-end]');if(!els.length)return;const tick=()=>{els.forEach(el=>{const end=new Date(el.getAttribute('data-countdown-end')).getTime();const now=Date.now();const diff=end-now;if(isNaN(end)){el.hidden=true;return;}if(diff<=0){const expired=el.getAttribute('data-countdown-expired');if(expired){el.innerHTML=expired;}else{el.hidden=true;}return;}const d=Math.floor(diff/86400000);const h=Math.floor(diff%86400000/3600000);const m=Math.floor(diff%3600000/60000);const s=Math.floor(diff%60000/1000);const pad=n=>String(n).padStart(2,'0');const dayEl=el.querySelector('[data-countdown-days]');const dayUnit=el.querySelector('[data-countdown-days-unit]');if(dayEl){if(d>0){dayEl.textContent=pad(d);if(dayUnit)dayUnit.hidden=false;}else if(dayUnit){dayUnit.hidden=true;}}const hourEl=el.querySelector('[data-countdown-hours]');if(hourEl)hourEl.textContent=pad(h);const minEl=el.querySelector('[data-countdown-minutes]');if(minEl)minEl.textContent=pad(m);const secEl=el.querySelector('[data-countdown-seconds]');if(secEl)secEl.textContent=pad(s);});};tick();this.countdownInterval=setInterval(tick,1000);}
  initAnnouncementMarquee(){document.querySelectorAll('[data-announcement-viewport]').forEach(viewport=>{const group=viewport.querySelector('[data-announcement-group]');if(!group||!group.offsetWidth)return;const seconds=parseFloat(viewport.dataset.rotateSeconds)||6;const pxPerSecond=Math.max(24,360/seconds);viewport.style.setProperty('--announcement-duration',(group.offsetWidth/pxPerSecond)+'s');});}
  initCartRemove(){
    document.addEventListener('click',async e=>{
      const btn=e.target.closest('[data-cart-remove]');
      if(!btn)return;
      e.preventDefault();
      const key=btn.getAttribute('data-cart-remove');
      if(!key||btn.disabled)return;
      btn.disabled=true;
      try{
        const res=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:0})});
        if(!res.ok)throw new Error('remove');
        if(btn.closest('.cart-page, .cart-table, .cart-lines')){location.reload();return;}
        await this.refreshCart();
      }catch(err){
        btn.disabled=false;
      }
    });
  }
  initCartVariantToggle(){
    if(this.cartVariantBound)return;
    this.cartVariantBound=true;
    document.addEventListener('click',async e=>{
      const btn=e.target.closest('[data-cart-variant-toggle] [data-variant-id]');
      if(!btn)return;
      const root=btn.closest('[data-cart-variant-toggle]');
      if(!root||btn.classList.contains('is-selected')||root.dataset.updating==='true')return;
      const newId=Number(btn.getAttribute('data-variant-id'));
      const key=root.getAttribute('data-line-key');
      const qty=Number(root.getAttribute('data-quantity')||1)||1;
      if(!newId||!key)return;
      this.paintCartVariant(root,btn);
      root.dataset.updating='true';
      try{
        const cart=await this.swapCartVariant(key,newId,qty);
        this.syncCartLineAfterSwap(root,key,newId,cart);
        this.applyCartTotals(cart);
        this.syncUpsells(cart);
      }catch(err){
        root.dataset.updating='false';
      }
    });
  }
  paintCartVariant(root,btn){
    const productId=String(root.dataset.productId);
    const variantId=btn.getAttribute('data-variant-id');
    document.querySelectorAll(`[data-cart-variant-toggle][data-product-id="${productId}"]`).forEach(el=>{
      el.querySelectorAll('[data-variant-id]').forEach(pill=>{
        const on=pill.getAttribute('data-variant-id')===variantId;
        pill.classList.toggle('is-selected',on);
        pill.setAttribute('aria-checked',on?'true':'false');
      });
      const line=el.closest('.cart-line, .drawer-item');
      const map=this.cartVariantMap()[productId]||[];
      const variant=map.find(v=>String(v.id)===variantId);
      if(variant?.image){
        const photo=line?.querySelector('img');
        if(photo)photo.src=variant.image;
      }
    });
  }
  async swapCartVariant(key,newId,qty){
    const json={method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'}};
    const add=await fetch('/cart/add.js',{...json,body:JSON.stringify({items:[{id:newId,quantity:qty}]})});
    if(!add.ok)throw new Error('add');
    const remove=await fetch('/cart/change.js',{...json,body:JSON.stringify({id:key,quantity:0})});
    if(!remove.ok)throw new Error('remove');
    return remove.json();
  }
  syncCartLineAfterSwap(root,oldKey,newId,cart){
    const item=(cart.items||[]).find(i=>Number(i.variant_id)===newId||Number(i.id)===newId);
    const lines=[...document.querySelectorAll('[data-cart-variant-toggle]')].filter(el=>el.dataset.productId===root.dataset.productId);
    if(!item){
      lines.forEach(el=>el.dataset.updating='false');
      return;
    }
    const leftover=lines.filter(el=>el.getAttribute('data-line-key')===oldKey);
    const keep=lines.filter(el=>el.getAttribute('data-line-key')!==oldKey);
    if(keep.length&&leftover.length){
      leftover.forEach(el=>el.closest('.cart-line, .drawer-item')?.remove());
      keep.forEach(el=>this.patchCartLineKeys(el,item));
      return;
    }
    lines.forEach(el=>this.patchCartLineKeys(el,item));
  }
  patchCartLineKeys(root,item){
    root.dataset.lineKey=item.key;
    root.dataset.quantity=String(item.quantity);
    root.dataset.updating='false';
    const line=root.closest('.cart-line, .drawer-item');
    if(!line)return;
    line.querySelectorAll('[data-cart-qty]').forEach(el=>el.dataset.cartQty=item.key);
    line.querySelectorAll('[data-cart-remove]').forEach(el=>el.setAttribute('data-cart-remove',item.key));
    const qtyInput=line.querySelector('.qty-input');
    if(qtyInput){
      qtyInput.value=item.quantity;
      const name=qtyInput.getAttribute('name');
      if(name&&name.startsWith('updates['))qtyInput.setAttribute('name',`updates[${item.key}]`);
    }
    if(item.image){
      const photo=line.querySelector('img');
      if(photo)photo.src=item.image;
    }
    root.querySelectorAll('[data-variant-id]').forEach(el=>{
      const on=Number(el.getAttribute('data-variant-id'))===Number(item.variant_id||item.id);
      el.classList.toggle('is-selected',on);
      el.setAttribute('aria-checked',on?'true':'false');
    });
  }
  applyCartTotals(cart){
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    const money=this.money(cart.total_price);
    document.querySelectorAll('[data-drawer-subtotal]').forEach(el=>el.textContent=money);
    document.querySelectorAll('.cart-footer__subtotal strong').forEach(el=>el.textContent=money);
    this.renderCartDiscounts(cart);
  }
  renderCartDiscounts(cart){
    const apps=cart.cart_level_discount_applications||[];
    document.querySelectorAll('[data-cart-discounts]').forEach(el=>{
      el.hidden=!apps.length;
      el.innerHTML=apps.map(d=>`<div class="cart-discounts__row"><span>${this.escape(d.title)}</span><strong>−${this.money(d.total_allocated_amount)}</strong></div>`).join('');
    });
    const showCompare=cart.items_subtotal_price>cart.total_price;
    document.querySelectorAll('[data-subtotal-compare]').forEach(el=>{
      el.hidden=!showCompare;
      el.textContent=showCompare?this.money(cart.items_subtotal_price):'';
    });
  }
  cartVariantMap(){
    if(this._cartVariantMap)return this._cartVariantMap;
    const el=document.querySelector('[data-cart-variant-map]');
    try{this._cartVariantMap=JSON.parse(el?el.textContent:'{}')||{};}catch(e){this._cartVariantMap={};}
    return this._cartVariantMap;
  }
  swatchClass(color){
    const c=String(color||'').toLowerCase();
    if(/noir|black/.test(c))return 'black';
    if(/blanc|white/.test(c))return 'white';
    if(/rouge|red/.test(c))return 'red';
    if(/vert|green/.test(c))return 'green';
    return 'default';
  }
  cartVariantMarkup(item){
    const variants=this.cartVariantMap()[String(item.product_id)];
    if(!variants||variants.length<2)return '';
    const pills=variants.map(v=>{
      const selected=Number(v.id)===Number(item.variant_id);
      return `<button type="button" class="variant-toggle__btn${selected?' is-selected':''}" role="radio" aria-checked="${selected?'true':'false'}" data-color="${this.escape(v.color)}" data-variant-id="${v.id}"${v.available?'':' disabled'}><span class="variant-toggle__swatch variant-toggle__swatch--${this.swatchClass(v.color)}" aria-hidden="true"></span>${this.escape(v.color)}</button>`;
    }).join('');
    return `<div class="variant-toggle variant-toggle--cart" data-cart-variant-toggle data-line-key="${this.escape(item.key)}" data-quantity="${item.quantity}" data-product-id="${item.product_id}"><div class="variant-toggle__pills" role="radiogroup">${pills}</div></div>`;
  }
  async refreshCart(){
    const cart=await fetch('/cart.js').then(r=>r.json());
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    const body=document.querySelector('[data-drawer-body]');
    const subtotal=document.querySelector('[data-drawer-subtotal]');
    if(body){
      if(!cart.items.length){
        body.innerHTML='<p>'+((window.BV_I18N||{}).cart_empty||'Votre panier est vide.')+'</p>';
      }else{
        body.innerHTML=cart.items.map(i=>{
          const included=this.includedCopy(i.handle);
          return `<div class="drawer-item">${i.image?`<img src="${i.image}" alt="">`:''}<div><strong>${this.escape(i.product_title)}</strong>${this.cartVariantMarkup(i)}${included?`<p class="drawer-item__included">${this.escape(included)}</p>`:''}<div class="drawer-item__qty">${this.qtyMarkup(i.key,i.quantity)}${this.cartUnitPrice(i)}</div></div><div class="drawer-item__meta">${this.cartLinePrice(i)}<button type="button" class="drawer-item__remove" data-cart-remove="${this.escape(i.key)}" aria-label="${(window.BV_I18N||{}).remove||'Retirer du panier'}">${this.trashIcon()}</button></div></div>`;
        }).join('');
      }
    }
    if(subtotal)subtotal.textContent=this.money(cart.total_price);
    this.renderCartDiscounts(cart);
    this.syncUpsells(cart);
  }
  money(cents){return new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:window.Shopify?.currency?.active||'EUR'}).format(cents/100)}
  readCompareMap(){
    const el=document.querySelector('[data-compare-prices]');
    if(!el)return {};
    try{return JSON.parse(el.textContent)||{};}catch(e){return {};}
  }
  cartCompare(item){return Number(this.compareAt[item.variant_id]||0)}
  cartUnitPrice(item){
    const compare=this.cartCompare(item);
    const sale=compare>item.final_price;
    return `<span class="cart-price${sale?' cart-price--sale':''}"><span>× ${this.money(item.final_price)}</span>${sale?`<s>${this.money(compare)}</s>`:''}</span>`;
  }
  cartLinePrice(item){
    const compare=this.cartCompare(item);
    const sale=compare>item.final_price;
    return `<span class="cart-price${sale?' cart-price--sale':''}"><strong>${this.money(item.final_line_price)}</strong>${sale?`<s>${this.money(compare*item.quantity)}</s>`:''}</span>`;
  }
  escape(s){const d=document.createElement('div');d.textContent=s||'';return d.innerHTML}
  trashIcon(){return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16"/><path d="M9 7V5.8A1.8 1.8 0 0 1 10.8 4h2.4A1.8 1.8 0 0 1 15 5.8V7"/><path d="M6.5 7 7.4 19.2A1.8 1.8 0 0 0 9.2 21h5.6a1.8 1.8 0 0 0 1.8-1.8L17.5 7"/><path d="M10 11v6M14 11v6"/></svg>'}
  qtyMarkup(key,qty){return `<div class="qty-selector qty-selector--compact" data-cart-qty="${this.escape(key)}"><button type="button" class="qty-btn" data-qty-change="-1" aria-label="${(window.BV_I18N||{}).qty_minus||'Diminuer la quantité'}">−</button><div class="qty-value"><input class="qty-input" type="number" value="${qty}" min="1" inputmode="numeric" aria-label="Quantité"></div><button type="button" class="qty-btn" data-qty-change="1" aria-label="${(window.BV_I18N||{}).qty_plus||'Augmenter la quantité'}">+</button></div>`}
}
document.addEventListener('DOMContentLoaded',()=>new BelverdiaTheme());
